import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Keyboard, KeyboardResizeMode } from '@awesome-cordova-plugins/keyboard/ngx';
import { NavController } from '@ionic/angular';
import { RadioModel } from '../../../personal-data/model/radio.model';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { AddressService } from '../../services/address.service';
@Component({
  selector: 'app-address-city',
  templateUrl: './address-city.component.html',
  styleUrls: ['./address-city.component.scss'],
})
export class AddressCityComponent extends DefaultPageComponent implements OnInit {

  selectedItem = '';
  selectedName = '';
  textSearch: string;
  public idComponentName = 'addressCity';
  buttonEnable = false;
  idLabel = 'nameCityLabel';
  label = 'Nome da cidade';
  startStage = '';
  endStage = '';
  fieldSearch = 'value';
  loading = true;
  showRetry = false;
  city = new Array<RadioModel>();
  @ViewChild('content') content: ElementRef;
  headerId = 'address-city';
  titlePage = 'Endereço';
  analyticsPage: AnalyticsPageModel;

  constructor(
    public router: NavController,
    private addressService: AddressService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private keyBoard: Keyboard,
    private domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.configureDomain(null, DomainDataType.City);
    this.analyticsData();
    this.getTrack();
    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainCity();
    this.editFieldInvest('cidade', 'cityName', 'address');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }
  
  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'address';

    this.startStage = track.getIndexPage(this.headerId, path).toString();
    this.endStage = track.getTotalPage(path).toString();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.addressCity;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }


  backPage() {
    this.analyticsEventClique();
    if (!this.addressService.addressInitalPostCode?.district
      && this.addressService.addressInitalPostCode?.state) {
        return this.router.navigateBack(['address', 'district']);
    }
    if (this.addressService.addressInitalPostCode?.district
      && this.addressService.addressInitalPostCode?.state) {
        return this.router.navigateBack(['address', 'adjunt']);
    }

    this.back();
  }

  clickNext() {
    this.addressService.setAddressCityName(this.selectedItem);
    this.addressService.setAddressCity(this.selectedName);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.addressCity
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
  }

  ionViewDidLeave() {
    this.textSearch = '';
    this.city = this.orderList(this.city, this.selectedItem);
    this.ariaHidden = true;
  }

  getDomainCity() {
    const filterCity = this.journeyService.registratioJourney.data.address.state;

    this.domainFactory.getDomainService(this.domainOrigin)
    .getDomains(this.domainDataType, filterCity).then((dominios) => {
      if (dominios?.length > 0) {
        
        this.city = this.orderList(dominios, this.journeyService.registratioJourney.data.address?.city &&
          this.journeyService.registratioJourney.data.address?.cityName);
        this.showRetry = false;
      } else {
        this.showRetry = true;
        this.headerFocus();
      }
    }).catch((err) => {
      this.showRetry = true;
    }).finally(() => {
      this.loading = false;
      this.headerFocus();
    });
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== '') {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter(value => value.key === selectedItem),
        ...dataOrder.filter(value => value.key !== selectedItem)
      ];
    }
    return data;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.address?.city &&
        this.journeyService.registratioJourney.data.address?.cityName) {
      this.selectedItem = this.journeyService.registratioJourney.data.address.cityName;
      this.selectedName = this.journeyService.registratioJourney.data.address.city;
    }
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTop(0, 0), 200);
  }

  changeValue() {
    this.city = this.orderList(this.city, this.selectedItem);
  }

}


